import { cn } from '@/lib/utils';

/**
 * ViewToggleButton — Atom
 * Individual button within the calendar view switcher (Day/Week/Month/Room/Doctor).
 */

interface ViewToggleButtonProps {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}

export function ViewToggleButton({ label, isActive = false, onClick }: ViewToggleButtonProps) {
  return (
    <button
      onClick={onClick}
      role="tab"
      aria-selected={isActive}
      className={cn(
        'px-3 py-1 text-[length:var(--type-label-size)] leading-[var(--type-label-line)] font-medium rounded-md transition-colors',
        isActive
          ? 'bg-surface-card text-brand-primary shadow-sm'
          : 'text-text-muted hover:text-text-primary'
      )}
    >
      {label}
    </button>
  );
}
